
import { setStroe } from '@/util/util.js'
const side = {
  state: {
    config: {}
  },
  mutations: {
    setConfig(state, config) {
      state.config = config
      setStroe({
        name: "config",
        content: config,
      })
    }
  },
  actions: {
  },
}
export default side